<script lang="ts">
  import { store, type TagSignal } from '../lib/stores.svelte.js';

  const signals: TagSignal[] = ['Trade Promotion', 'Distribution Push', 'Key Account'];

  function countFor(sig: TagSignal) {
    let n = 0;
    for (const t of store.tagged.values()) if (t.signal === sig) n++;
    return n;
  }

  function toggle(filter: TagSignal | 'All') {
    store.tagFilter = store.tagFilter === filter ? null : filter;
  }
</script>

<div class="bar">
  <button
    class="chip"
    class:active={store.tagFilter === 'All'}
    onclick={() => toggle('All')}
  >All ({store.tagged.size})</button>
  {#each signals as s (s)}
    <button
      class="chip"
      class:active={store.tagFilter === s}
      onclick={() => toggle(s)}
    >{s} ({countFor(s)})</button>
  {/each}
  {#if store.tagged.size > 0}
    <button class="view-plan" onclick={() => (store.taggedOpen = true)}>
      View tagged plan →
    </button>
  {/if}
</div>

<style>
  .bar {
    display: inline-flex;
    align-items: center;
    gap: var(--space-xs);
    flex-wrap: wrap;
  }
  .chip {
    font-family: var(--font-ui);
    font-size: var(--text-xs);
    font-weight: var(--weight-semibold);
    letter-spacing: var(--tracking-wide);
    color: var(--color-text-muted);
    background: var(--color-white);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-full);
    padding: 4px 10px;
    cursor: pointer;
  }
  .chip:hover { color: var(--color-blue); border-color: var(--color-blue); }
  .chip.active {
    background: var(--color-blue);
    color: var(--color-white);
    border-color: var(--color-blue);
  }
  .view-plan {
    margin-left: var(--space-sm);
    font-family: var(--font-ui);
    font-size: var(--text-xs);
    font-weight: var(--weight-semibold);
    background: transparent;
    color: var(--color-blue);
    border: none;
    cursor: pointer;
    text-transform: uppercase;
    letter-spacing: var(--tracking-wide);
  }
  .view-plan:hover { text-decoration: underline; }
</style>
